/**
 * HUB-D — KPI caisse (sessions, ventes, retraits, coffre, écart).
 */
import React from 'react';
import { formatEuro } from '../../utils/caisse/caisseDisplay';

export default function ActiviteCaisseKpiStrip({ kpis, openStatus }) {
  return (
    <div className="space-y-3" data-testid="activite-caisse-kpi">
      {openStatus?.is_open && (
        <div
          className="rounded-xl border p-3 text-sm"
          style={{ borderColor: 'rgba(22, 163, 74, 0.35)', background: 'var(--rm-success-muted)' }}
          data-testid="activite-caisse-open-banner"
        >
          <span className="font-semibold text-[var(--rm-white)]">Caisse ouverte</span>
          <span className="text-[var(--rm-gray-400)] ml-2">
            {openStatus.date_caisse} · {openStatus.magasin_id || 'M1'} · {openStatus.opened_by || '—'}
          </span>
        </div>
      )}
      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 text-sm">
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-caisse-sessions">
          <div className="text-xs text-[var(--rm-gray-500)]">Sessions</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.sessionCount ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-caisse-open">
          <div className="text-xs text-[var(--rm-gray-500)]">Ouvertes</div>
          <div className="font-bold text-[var(--rm-success)]">{kpis?.openCount ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-caisse-ventes">
          <div className="text-xs text-[var(--rm-gray-500)]">Ventes période</div>
          <div className="font-bold text-[var(--rm-success)]">{formatEuro(kpis?.totalVentes)}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-caisse-retraits">
          <div className="text-xs text-[var(--rm-gray-500)]">Retraits</div>
          <div className="font-bold text-[var(--rm-red-light)]">{formatEuro(kpis?.totalRetraits)}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-caisse-coffre">
          <div className="text-xs text-[var(--rm-gray-500)]">Dépôts coffre</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{formatEuro(kpis?.totalCoffre)}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-caisse-ecart">
          <div className="text-xs text-[var(--rm-gray-500)]">Écart cumulé</div>
          <div className={`font-bold ${Number(kpis?.ecartSum || 0) >= 0 ? 'text-[var(--rm-success)]' : 'text-[var(--rm-red-light)]'}`}>
            {formatEuro(kpis?.ecartSum)}
          </div>
        </div>
      </div>
    </div>
  );
}
